import { JUNE_NAME as NAME, JUNE_DISPLAY_NAME as DISPLAY_NAME } from '../Destinations';

const DIR_NAME = 'June';

const DISPLAY_NAME_TO_DIR_NAME_MAP = { [DISPLAY_NAME]: DIR_NAME };
const CNameMapping = {
  [NAME]: NAME,
  June: NAME,
  june: NAME,
};

export { NAME, CNameMapping, DISPLAY_NAME_TO_DIR_NAME_MAP, DISPLAY_NAME, DIR_NAME };
